import React, { useState } from 'react';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  applicationNo: string;
  isDeleting: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

/**
 * 删除确认对话框
 * 防止误操作，明确提示删除后果
 */
export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  isOpen,
  applicationNo,
  isDeleting,
  onConfirm,
  onCancel,
}) => {
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    try {
      setError(null);
      await onConfirm();
    } catch (err) {
      setError(err instanceof Error ? err.message : '删除失败');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="clay-card p-6 max-w-sm mx-4 shadow-2xl">
        <div className="flex items-start gap-4 mb-4">
          <div className="text-3xl">⚠️</div>
          <div>
            <h2 className="text-lg font-semibold text-slate-800 mb-1">删除草稿申请</h2>
            <p className="text-sm text-slate-600">
              此操作无法撤销
            </p>
          </div>
        </div>

        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-slate-700 mb-2">
            <span className="font-medium">申请单号：</span>
            <span className="text-red-600 font-semibold">{applicationNo}</span>
          </p>
          <p className="text-sm text-slate-600">
            删除后，该草稿将被永久移除，无法恢复。
          </p>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
            <p className="text-sm text-red-600">❌ {error}</p>
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="flex-1 px-4 py-2 rounded-xl font-medium text-slate-700 bg-slate-100 hover:bg-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            取消
          </button>
          <button
            onClick={handleConfirm}
            disabled={isDeleting}
            className="flex-1 px-4 py-2 rounded-xl font-medium text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
          >
            {isDeleting ? (
              <>
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                <span>删除中...</span>
              </>
            ) : (
              <span>确认删除</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
